// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scientia-footer {
  display: block;
  width: 100vw;
  height: 300px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  overflow: hidden;
  background: #2E313A;
}
@media screen and (max-width: 1200px) {
  .scientia-footer {
    display: block;
  }
}
.footer-frame {
  display: flex;
  width: 100vw;
  height: 250px;
  padding: 10px 30px 10px 20px;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  flex-shrink: 0;
}
@media screen and (max-width: 1200px) {
  .footer-frame {
    display: block;
    align-items: center;
  }
}
.footer-frame .footer-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 150px;
  margin-top: 10px;
}
@media screen and (max-width: 1200px) {
  .footer-frame .footer-left {
    display: block;
  }
}
@media screen and (max-width: 1400px) {
  .footer-frame .footer-left {
    margin-right: 50px;
  }
}
.footer-frame .footer-left .footer-logo-frame {
  display: flex;
  width: 350px;
  height: 70px;
  align-items: flex-start;
}
@media screen and (max-width: 1200px) {
  .footer-frame .footer-left .footer-logo-frame {
    display: flex;
  }
}
@media screen and (max-width: 678px) {
  .footer-frame .footer-left .footer-logo-frame {
    display: block;
    height: 100px;
  }
}
.footer-frame .footer-left .footer-logo-frame .footer-logo {
  width: 120px;
  height: 64px;
  flex-shrink: 0;
}
@media screen and (max-width: 1400px) {
  .footer-frame .footer-left .footer-logo-frame .footer-logo {
    width: 117px;
    height: 67px;
  }
}
.footer-frame .footer-left .footer-logo-frame .footer-logo a {
  display: block;
}
.footer-frame .footer-left .footer-logo-group {
  display: flex;
  width: 350px;
  align-items: flex-end;
  opacity: 0.8;
  padding-left: 10px;
  margin-top: 20px;
}
@media screen and (max-width: 1200px) {
  .footer-frame .footer-left .footer-logo-group {
    width: 85vw;
    align-items: center;
  }
}
.footer-frame .footer-left .footer-logo-group .icon-cont {
  background-color: #0aea7f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid black;
  margin-right: 5px;
}
.footer-frame .footer-left .footer-logo-group .icon {
  width: 25px;
  height: 25px;
}
.footer-frame .footer-right {
  display: flex;
  width: -250vw;
  padding: 17px 0px 0px 20px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  flex-shrink: 0;
}
@media screen and (max-width: 1200px) {
  .footer-frame .footer-right {
    display: block;
  }
}
.footer-frame .footer-right .footer-right-frame {
  display: flex;
  height: 190px;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  margin-bottom: 60px;
}
@media screen and (max-width: 768px) {
  .footer-frame .footer-right .footer-right-frame {
    display: none;
  }
}
.footer-frame .footer-right .footer-right-frame .link-col1,
.footer-frame .footer-right .footer-right-frame .link-col2,
.footer-frame .footer-right .footer-right-frame .link-col3 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  padding-right: 100px;
}
.footer-links {
  display: flex;
  padding-bottom: 2px;
  align-items: flex-start;
  gap: 8px;
  color: #66d1ff;
  background-color: #2E313A;
  border: none;
  /* SemiBold Body Text */
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: none;
}
.footer-links:hover {
  color: #A0E2FF;
  text-decoration: underline;
}
@media screen and (max-width: 1400px) {
  .footer-links {
    font-size: 13px;
  }
}
.separator {
  margin-top: -10px;
  transform: scale(0.1, 1);
  color: white;
  font-size: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ScientiaFooter.less"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,YAAA;EACA,aAAA;EAEA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAKI;EAAA;IACI,cAAA;EAFN;AACF;AAKA;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAHJ;AAII;EAAA;IACI,cAAA;IACA,mBAAA;EADN;AACF;AAXA;EAeI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAEI;EAAA;IACI,cAAA;EACN;AACF;AAAI;EAAA;IACI,kBAAA;EAGN;AACF;AA5BA;EA2BQ,aAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AAIR;AAHQ;EAAA;IACI,aAAA;EAMV;AACF;AALQ;EAAA;IACQ,cAAA;IACA,aAAA;EAQd;AACF;AA7CA;EAuCY,YAAA;EACA,YAAA;EACA,cAAA;AASZ;AARY;EAAA;IACI,YAAA;IACA,YAAA;EAWd;AACF;AAxDA;EAgDY,cAAA;AAWZ;AA3DA;EAoDQ,aAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAUR;AATQ;EAAA;IACI,WAAA;IACA,mBAAA;EAYV;AACF;AAzEA;EA+DY,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;AAaZ;AApFA;EA0EY,WAAA;EACA,YAAA;AAaZ;AAxFA;EAiFI,aAAA;EACA,aAAA;EACA,0BAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;AAUJ;AATI;EAAA;IACI,cAAA;EAYN;AACF;AAtGA;EA6FQ,aAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAYR;AAXQ;EAAA;IACI,aAAA;EAcV;AACF;AAnHA;;;EAuGY,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;AAiBZ;AAZA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EAcF,uBAAuB;EAXrB,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAaJ;AAZI;EACI,cAAA;EACA,0BAAA;AAcR;AAZI;EAAA;IACI,eAAA;EAeN;AACF;AAZA;EACI,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;AAcJ","sourcesContent":["@import \"../styles/scientia-colors.less\";\n\n.scientia-footer {\n    display: block;\n    width: 100vw;\n    height: 300px;\n \n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    overflow: hidden;\n    background: @scientia-footer-background;\n\n    \n    @media screen and (max-width: 1200px) {\n        display: block;\n      }\n    \n}\n.footer-frame {\n    display: flex;\n    width: 100vw;\n    height: 250px;\n    padding: 10px 30px 10px 20px;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 30px;\n    flex-shrink: 0;\n    @media screen and (max-width: 1200px) {\n        display: block;\n        align-items: center\n      }\n\n.footer-left {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-right: 150px;\n    margin-top: 10px;\n    @media screen and (max-width: 1200px) {\n        display: block;\n      }\n    @media screen and (max-width: 1400px) {\n        margin-right: 50px;\n      }\n    .footer-logo-frame {\n        display: flex;\n        width: 350px;\n        height: 70px;\n        align-items: flex-start;\n        @media screen and (max-width: 1200px) {\n            display: flex;\n            }\n        @media screen and (max-width: 678px) {\n                display: block;\n                height: 100px;\n            }\n        .footer-logo{\n            width: 120px;\n            height: 64px;\n            flex-shrink: 0;\n            @media screen and (max-width: 1400px) {\n                width: 117px;\n                height: 67px;\n                }    \n        }\n        .footer-logo a {\n            display: block;\n        }\n    }\n    .footer-logo-group {\n        display: flex;\n        width: 350px;\n        align-items: flex-end;\n        opacity: 0.8;\n        padding-left: 10px;\n        margin-top: 20px;\n        @media screen and (max-width: 1200px) {\n            width: 100vw - 15px;\n            align-items: center;\n            }\n        .icon-cont {\n            background-color:@scientia-active-green;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            border: 1px solid black;\n            margin-right: 5px;\n        }\n        .icon {\n            width: 25px;\n            height: 25px;\n        }\n    }\n\n}\n.footer-right {\n    display: flex;\n    width: 100vw - 350px;\n    padding: 17px 0px 0px 20px;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-start;\n    flex-shrink: 0;\n    @media screen and (max-width: 1200px) {\n        display: block;\n    }\n\n    .footer-right-frame {\n        display: flex;\n        height: 190px;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 40px;\n        margin-bottom: 60px;\n        @media screen and (max-width: 768px) {\n            display: none;\n        }\n        .link-col1, .link-col2, .link-col3 {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 15px;\n            padding-right: 100px;\n        }\n    }\n}\n}\n.footer-links {\n    display: flex;\n    padding-bottom: 2px;\n    align-items: flex-start;\n    gap: 8px;\n    color: @scientia-blue;\n    background-color: @scientia-footer-background;\n    border: none;\n\n    /* SemiBold Body Text */\n    font-family: \"Open Sans\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-decoration: none;\n    &:hover{\n        color: @scientia-button-hover-blue;\n        text-decoration: underline;\n    }\n    @media screen and (max-width: 1400px) {\n        font-size: 13px;\n    }\n\n}\n.separator {\n    margin-top: -10px;\n    transform: scale(0.1,1);\n    color: white;\n    font-size: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
